/** */
import axios from 'axios'

//const url = "http://localhost:5000/api/"
const url = process.env.NODE_ENV === 'production' ? "/api/" : "http://localhost:5000/"

export function loadProjects() {
    return (dispatch) => {
        axios.get(`${url}project`)
            .then((res) => {
                let projects = res.data
                dispatch({ type: 'LOAD_PROJECTS', projects })
            }).catch((err) => {
                console.log(err)
            })
    }
}
export function getUser(id) {
    return axios.get(`${url}user/${id}`).then((res) => {
        return res.data
    }).catch(err => console.log(err))
}

export function getUserProfile(id) {
    return (dispatch) => {
        axios.get(`${url}user/profile/${id}`).then((res) => {
            let profile = res.data
            dispatch({ type: 'SET_PROFILE', profile })
        }).catch(err => console.log(err))
    }
}

export function getProject(project_id) {
    return (dispatch) => {
        axios.get(`${url}project/${project_id}`)
            .then((res) => {
                let project = res.data
                dispatch({ type: 'VIEW_PROJECT', project })
            }).catch((err) => console.log(err))
    }
}
// project_id, authorid, comment
export function comment() {
    return (dispatch) => {

    }
}
//req.body.project_id
export function clap(project_id) {
    return (dispatch) => {
        axios.post(`${url}project/clap`, { project_id }).then((res) => {
            dispatch({ type: 'CLAP_PROJECT' })
        }).catch((err) => console.log(err))
    }
}
//id, user_id
export function follow(id, user_id) {
    return (dispatch) => {
        axios.post(`${url}user/follow`, { id, user_id }).then((res) => {
            dispatch({ type: 'FOLLOW_USER', user_id })
        }).catch((err) => console.log(err))
    }
}

export function SignInUser(user_data) {
    return (dispatch) => {
        axios.post(`${url}user`, user_data).then((res) => {
            let user = res.data
            localStorage.setItem('Auth', JSON.stringify(user))
            dispatch({ type: 'SET_USER', user })
        }).catch((err) => console.log(err))
    }
}

export function toggleClose() {
    return (dispatch) => {
        dispatch({ type: 'TOGGLE_MODAL', modalMode: false })
    }
}
export function toggleOpen() {
    return (dispatch) => {
        dispatch({ type: 'TOGGLE_MODAL', modalMode: true })
    }
}


// WEBPACK FOOTER //
// ./src/redux/actions/actions.js